import { computed, onBeforeUnmount, onMounted, ref } from "vue";

// Watches the html.dark class directly rather than the dark-mode store: this stays correct
// whatever sets that class, including the Storybook toolbar toggle, which never touches the store.
export function useChatTheme() {
  const isDark = ref(document.documentElement.classList.contains("dark"));
  let observer: MutationObserver | null = null;

  onMounted(() => {
    isDark.value = document.documentElement.classList.contains("dark");
    observer = new MutationObserver(() => {
      isDark.value = document.documentElement.classList.contains("dark");
    });
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ["class"] });
  });

  onBeforeUnmount(() => observer?.disconnect());

  const themeClass = computed(() => ({
    "chat-theme": true,
    "chat-theme--light": !isDark.value,
    "chat-theme--dark": isDark.value,
  }));

  return {
    isDark,
    themeClass,
  };
}
